// externals
import type { Reducer } from 'redux';
import { Actions } from '../actionTypes/actionTypes';
import { getInitialModalDetails } from './confirmNavigationInitialState';
import type { ConfirmNavigationModalState } from './types';

export const confirmNavigationModal: Reducer<ConfirmNavigationModalState> = (
    state: ConfirmNavigationModalState = getInitialModalDetails(),
    action: any
) => {
    const { payload, type } = action;

    switch (type) {
        case Actions.SHOW_CONFIRM_NAVIGATION_MODAL: {
            return {
                ...state,
                title: payload.title,
                message: payload.message,
                onConfirm: payload.onConfirm,
                onCancel: payload.onCancel,
                show: true
            };
        }

        case Actions.HIDE_CONFIRM_NAVIGATION_MODAL: {
            return {
                ...state,
                ...getInitialModalDetails()
            };
        }
        default: {
            return state;
        }
    }
};
